import { useOrganizationId } from '@/hooks/useSwr';
import { addQueryParams } from '@/utils/add-query-params';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HubSearchCrumb(props: Partial<BreadcrumbData>) {
  const organizationId = useOrganizationId();
  const innerPath =
    props.path === '#' ? '#' : addQueryParams(props.path, { organizationId });
  return <Breadcrumb path={innerPath} name="Search" />;
}
